import { Component } from '@angular/core';

@Component({
  selector: 'app-analytics',
  template: `
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h2 class="page-title">Analytics</h2>
        </div>
      </div>
      
      <mat-tab-group>
        <mat-tab label="Recruiter Analytics">
          <app-recruiter-analytics></app-recruiter-analytics>
        </mat-tab>
        <mat-tab label="Sales Analytics">
          <app-sales-analytics></app-sales-analytics>
        </mat-tab>
      </mat-tab-group>
    </div>
  `,
  styles: [`
    .page-title {
      margin-bottom: 20px;
    }
  `]
})
export class AnalyticsComponent {} 